import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { MaterialDelivery } from 'src/app/_model/material-delivery';

@Injectable()
export abstract class MaterialDeliveriesDaoService implements Resetable {
  public abstract saveMaterialDeliveries(
    materialDDeliveries: MaterialDelivery[],
  ): Promise<void>;
  public abstract getMaterialDeliveries(): Promise<MaterialDelivery[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
